import PropTypes from 'prop-types';
import styles from './TextHighlight.module.scss';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';
import PurifiedHtml from '../../PurifiedHtml/PurifiedHtml';

const TextHighlight = ({
  text,
  textToHighlight,
  highlightClassName,
  isEscape,
  className
}) => {
  // to create string from test to t|te|tes|test
  const queryString = term => {
    const results = {};
    term.split('').forEach((_, index) => {
      for (let j = 0; j < index; j++) {
        const sub = term
          .substring(j, index + 1)
          .replace(/[.*+\-?^${}()|[\]\\\s/]/g, '');
        results[sub] = sub;
      }
    });
    const termsArray = Object.values(results)
      .filter(n => n.length > 1)
      .sort((a, b) => b.length - a.length);
    return termsArray.join('|');
  };
  // ended

  const regex = isEscape
    ? new RegExp(`(${queryString(textToHighlight)})`, 'gi')
    : new RegExp(`(${textToHighlight})`, 'gi');
  const parts = text.split(regex);

  if (!textToHighlight.trim()) {
    return <PurifiedHtml as="span" htmlString={text} />;
  }

  return (
    <span className={className}>
      {parts
        .filter(part => part)
        .map((part, i) =>
          regex.test(part) ? (
            <PurifiedHtml
              as="span"
              htmlString={part}
              data-testid="highlight-element"
              className={classnames(styles['highlight'], highlightClassName)}
              key={uuid()}
            />
          ) : (
            <PurifiedHtml as="span" htmlString={part} key={uuid()} />
          )
        )}
    </span>
  );
};

TextHighlight.propTypes = {
  text: PropTypes.string,
  textToHighlight: PropTypes.string,
  highlightClassName: PropTypes.string,
  isEscape: PropTypes.bool,
  className: PropTypes.string
};

export default TextHighlight;
